import { useSelector } from 'react-redux'

// The person logged in to Control Center (the name in the top bar). Leo saves it as who ran, closed or posted.
export function useLoggedInName(): string {
  const userData = useSelector((state: any) => state.userInfo?.userData)
  return String(userData?.name || userData?.username || '').trim()
}
